import styled from 'styled-components';

export const Banner = styled.div`
  position: sticky;
  display: flex;
  align-items: center;
  justify-content: center;
  border-color: blue;
  height: 50px;
  width: 100vw;
  background-color: ${props => props.color};
  font-weight: 800;
  opacity: 0.9;
  z-index: 2000;
  top: 0;
`;
